
const RouteUrl = {
    index: "/",
    initRedirect: "uk/",
    offers: "offers/",
    prices: "prices/",
    contacts: "contacts/",
    doctors: "doctors/",
    procedures: "procedures/",
    medicalFields: "medical-fields/",
    licence: "licence/",
    giftVoucher: "gift/",
    blog: "blog/",
    massages: "massages/",
    ru: "ru/"
};

export default RouteUrl;